import { currencyFormatter } from "../../../utils/AgGridUtils/ColumnBuilders/createColumn";
import { _CO, _MONTHS } from "../../../utils/constants";
export const ColumnBuilder = () => {
  const createColumn = (props) => ({
    flex: 1,
    editable: false,
    sortable: false,
    resizable: false,
    headerClass: "header-center",
    ...props,
  });

  const buildColumns = () => {
    const generatedColumns = [];

    generatedColumns.push(
      createColumn({
        headerName: "",
        field: "rowName",
        suppressHeaderMenuButton: true,
        width: 300,
      }),
    );

    for (let i = 1; i <= 12; i++) {
      const fiscalMonthIndex = _CO[i];
      generatedColumns.push(
        createColumn({
          headerName: _MONTHS[fiscalMonthIndex],
          field: `${fiscalMonthIndex}`,
          editable: true,
          headerClass: "month-header",
          suppressHeaderMenuButton: true,
          type: "rightAligned",
          valueFormatter: (params) => {
            return currencyFormatter(params.value, "", 0);
          },
        }),
      );
    }

    generatedColumns.push(
      createColumn({
        headerName: "TOTAL",
        field: "total",
        editable: false,
        headerClass: "total-header-col",
        type: "rightAligned",
        suppressHeaderMenuButton: true,
        valueFormatter: (params) => {
          return currencyFormatter(params.value, "", 0);
        },
      }),
    );

    return generatedColumns;
  };

  return buildColumns();
};
